module.exports = __webpack_public_path__ + "img/legs_line.337c62a3.svg";